/**
 * i18n Configuration — FIDSNet Display Client
 * ─────────────────────────────────────────────────────────────────────────────
 * Supports dynamic language switching for international airports.
 * Server can push language changes via `device.languageChange` socket event.
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar", "fr", "zh", "es", "hi", "ja", "de", "pt", "th"],
    ns: ["display"],
    defaultNS: "display",
    backend: {
      loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json`,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "fidsnet_display_language",
    },
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    debug: import.meta.env.DEV,
  });

export default i18n;
